import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';

// Redux
import { saveDamageCategories, GetDamageCategories } from './index';

// Api's
import { damageSubCategoryApi } from '@/main/api';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getDamageCategoriesSaga(action: GetDamageCategories) {
  try {
    const response: AxiosResponse<Result<
      DamageCategoryResponse[]
    >> = yield call(
      damageSubCategoryApi.getDamageCategoriesSubCategories,
      action.payload.guidInsurer
    );

    if (response.data.result) {
      yield put(saveDamageCategories(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveDamageCategories(null, true, resultError.messagesDataError)
      );
    }
  }
}
